


































































































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';
import ProductCard from '~/modules/catalog/category/components/views/ProductCard.vue';
import { useImage, useUiState } from '~/composables';
import type { Product } from '~/modules/catalog/product/types';

import SvgImage from '~/components/General/SvgImage.vue';
import LinkWithArrow from '~/components/General/LinkWithArrow.vue';
import Banner from '~/components/Home/Banner.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';

export default defineComponent({
  components: {
    CategoryProductPrice,
    ProductCard,
    SkeletonLoader,
    Banner,
    LinkWithArrow,
    SvgImage,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup(props) {
    const { isCategoryGridView, toggleShippingModal } = useUiState();
    const { imageSizes: { productCard: imageSize } } = useImage();
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);

    const banners = [{
      title: 'What size of bed do you want to buy?',
      buttonText: 'Learn more about bed sizes.',
      link: '/404',
      background: 'var(--c-accent-6)',
    }, {
      title: 'Free Shipping',
      description: 'on orders over $1200',
      buttonText: 'Find out more',
      background: 'var(--c-accent-3)',
    }];

    return {
      imageSize,
      productsWithCommonProductCardProps,
      banners,
      isCategoryGridView,
      toggleShippingModal,
    };
  },
});
